export default __webpack_public_path__ + "0436e3acaaa77f5af7157d36c0f68464.png";